export const ROW_ACCENT_WIDTH = 3;
export const ROW_HEADER_PADDING_X = 16;
export const ROW_HEADER_PADDING_Y = 6;
export const ROW_HEADER_ITEM_GAP = 11;
export const ROW_HEADER_ROW_GAP = 6;
export const ROW_USERNAME_FONT_SIZE = 15;
export const ROW_FACT_FONT_SIZE = 11;

export const LANES_PADDING_X = 16;
export const LANE_COLUMN_GAP = 14;
export const LANE_PADDING_Y = 10;
export const LANE_PADDING_LEFT = 14;
export const LANE_HEADER_HEIGHT = 22;
export const LANE_HEADER_GAP = 7;
export const LANE_HEADER_MARGIN = 8;
export const LANE_TITLE_FONT_SIZE = 12;
export const LANE_FOOTER_GAP = 8;
export const LANE_FOOTER_PADDING_TOP = 8;

export const TILE_SOURCE_SIZE = 240;
export const TILE_SIZE = 170;
export const TILE_GAP = 9;
export const TILE_RADIUS_CSS = "9px";
export const TILE_ACTION_HEIGHT = 26;
export const TILE_ACTION_GAP = 5;
export const TILE_ACTION_ICON = 12;
export const TILE_ACTION_RADIUS_CSS = "6px";
export const TILE_BADGE_OFFSET = 5;
export const TILE_ZOOM_BOX = 22;
export const TILE_ZOOM_ICON = 11;

export const NO_PICTURES_HEIGHT = 92;
export const NO_PICTURES_PADDING = 14;
export const NO_PICTURES_GAP = 10;
export const NO_PICTURES_ICON = 22;
export const NO_PICTURES_FONT_SIZE = 12;
export const NO_PICTURES_RADIUS_CSS = "9px";

export const DESCRIPTION_TEXT_HEIGHT = 68;
export const DESCRIPTION_FONT_SIZE = 13;
export const DESCRIPTION_LINE_HEIGHT = 1.5;
